// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logoCircle":"displayBoxLogo__logoCircle--ggU6_","poweredBy":"displayBoxLogo__poweredBy--1-mpi","logo":"displayBoxLogo__logo--1bgY1"};